<template>
	<div>
		<el-tabs type="border-card" @tab-click="gaizhuangtai" v-model="tabs" @tab-remove="Tabremove">
			
			<el-tab-pane label="商品管理"  name="lie" >
				
				<el-form ref="form" :model="so" label-width="100px" >
					<el-col :span="5">
						<el-form-item label="关键字">
							<el-input v-model="so.guanjianci"></el-input>
						</el-form-item>
					</el-col>
					<!-- <el-form-item label="状态">
						<el-select v-model="so.zhuangtai" placeholder="请选择状态" style="width: 100%;">
							<el-option label="不限" value=""></el-option>
							<el-option label="上架" value="1"></el-option>
							<el-option label="下架" value="0"></el-option>
							<el-option label="待审核" value="5"></el-option>
						</el-select>
					</el-form-item> -->
				<!-- 	<el-col :span="5">
						<el-form-item label="分类">
							<Liandong :yiji.sync="so.yiji" :erji.sync="so.erji" :sanji.sync="so.sanji" :shu="fenleilie"></Liandong>
						</el-form-item>
					</el-col> -->
					<!-- <Tijiao @click="CSH" size="medium" type="info">搜索</Tijiao>		 -->
					<el-button type="info"  size="medium" @click="CSH"  style="margin:0 20px;" >搜索</el-button>
					<el-button type="primary"  size="medium" @click="Danchu" >导出Excel</el-button>
				</el-form>
				
				<el-table :data="lie" ref="huiYuanlie" style="width: 100%" stripe>
					
					<el-table-column  type="selection"  width="55"> </el-table-column>
					<el-table-column prop="id" label="ID" width="60"></el-table-column>
					<el-table-column label="排序" width="80">
						<template slot-scope="shu">
							<el-input size="mini"   @blur='gaishuxing({id:shu.row.id,shunxu:shu.row.shunxu})' v-model="shu.row.shunxu"></el-input>
						</template>
					</el-table-column>
					<el-table-column label="商品" width="340" style="position: relative;display: flex;">
						<template slot-scope="shu">
							<div  style="display: flex;">
								<el-image style="width: 50px; height:50px; margin-right:16px;" :src="shu.row.tu" fit="cover"></el-image>
								<div style="display: flex; flex-direction: column;">
									<div>
										<!-- <span class="leixin" v-if="shu.row.fenlei_yiji_ming">【{{shu.row.fenlei_yiji_ming}}】</span> -->
										<!-- <span class="leixin" v-if="shu.row.fenlei_erji_ming">【{{shu.row.fenlei_erji_ming}}】</span> -->
										<!-- <span class="leixin" v-if="shu.row.fenlei_sanji_ming">【{{shu.row.fenlei_sanji_ming}}】</span> -->
										<span class="leixin3" v-if="shu.row.shanghuming">
											<!-- <el-image  class="leixin5" src="http://shuimianbaobao.myuan.cn/gongyong/shangchuan/images/12/2019_10/geLtMywtdbTTEmtNN1wL6552mWYbDE.png" fit="cover"></el-image> -->
										{{shu.row.shanghuming}}</span>
										<el-tag type="danger" class="zhuantai" effect="dark" size="mini" v-if="shu.row.cuxiao==1">拼</el-tag>
									</div>
									<div>
										<span class="leixin4">{{shu.row.ming}}</span>
									</div>
								</div>
							</div>
						</template>
					</el-table-column>
				<!-- 	<el-table-column prop="zhanghao" label="商品属性" width="130" >
						<template slot-scope="shu">
							<span class="eltag el-tag el-tag--dark" :class="(shu.row.xinpin==1)?'':'el-tag--info'" @click="Biaoqian(shu.row,'xinpin',1)">新品</span>
							<span class="eltag el-tag el-tag--dark" :class="(shu.row.tuijian==1)?'':'el-tag--info'" @click="Biaoqian(shu.row,'tuijian',1)">推荐</span>						
						</template>
					</el-table-column> -->
					<!-- <el-table-column width="130" label="售价">
						<template slot-scope="shu">
							<div style="display: flex;">
								<el-input style="width: 120px;" size="mini" @blur="gaishuxing(shu.row,'jiage')" v-model="shu.row.jiage" placeholder="请输入内容">  <template slot="append">元</template></el-input>
							</div>
						</template>
					</el-table-column> -->
					<el-table-column width="130" label="成本价">
						<template slot-scope="shu">
							<div style="display: flex;">
								<el-input style="width: 120px;" size="mini" @blur="gaishuxing(shu.row,'chengben')" v-model="shu.row.chengben" placeholder="请输入内容">  <template slot="append">元</template></el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column width="130" label="库存">
						<template slot-scope="shu">
							<div style="display: flex;">
								<el-input style="width: 120px;" size="mini" @blur="gaishuxing(shu.row,'kucun')" v-model="shu.row.kucun" placeholder="请输入内容"> 
								 </el-input>
							</div>
						</template>
					</el-table-column>
					<el-table-column width="130" label="销量">
						<template slot-scope="shu">
							<div style="display: flex;">
								<el-input style="width: 120px;" size="mini" @blur="gaishuxing(shu.row,'chushoushu')" v-model="shu.row.chushoushu" placeholder="请输入内容">
									</el-input>
							</div>
						</template>
					</el-table-column>
					
					
				<!-- 	<el-table-column label="发布/更新时间">
						<template slot-scope="shu">
							<div>{{shu.row.shijian}}</div>
							<div>{{shu.row.gengxinshijian}}</div>
						</template>
					</el-table-column> -->
					
					<el-table-column label="状态" width="120">
						<template slot-scope="shu" >
							<div style="color: red;">
								<span v-if="shu.row.zhuangtai==0">放入仓库</span>
								<span v-if="shu.row.zhuangtai==1">出售中</span>
								<span v-if="shu.row.zhuangtai==4">回收站</span>
							</div>
							<!-- <el-select v-model="shu.row.zhuangtai" @change='Shangxiajia(shu.row)' placeholder="请选择">
								<el-option  v-for="(l,m) in zhuangtailie" :label="l.ming" :value="l.zhi" :key="m"></el-option>
							 </el-select> -->
						</template>
					</el-table-column>
				
					<el-table-column  label="操作"  width="180">
						<template slot-scope="shu">
							<el-button  icon="el-icon-edit-outline" size="small" @click="Bianji(shu.row)"></el-button>
							<el-button slot="reference" icon="el-icon-close" size="small" @click="Shanchu(shu.row)"></el-button>
							<el-button  icon="el-icon-document-copy" size="small"  @click="copyLink($event,shu.row.id)"></el-button>
						</template>
					</el-table-column>
				</el-table>
				
				<div style="display: flex;">
						<div  class="shangchu_shangchu0">
							<el-checkbox  @change="Xuanlie" ></el-checkbox>  <!-- <el-button type="danger" size="mini"></el-button> -->
							<div class="shangchu_shangchu1"   @click="ShanchuHuiYuan">删除</div>
							<!-- <div class="shangchu_shangchu2"   @click="yijiancaozuo(1)">一键上架</div> -->
							<!-- <div class="shangchu_shangchu3"   @click="yijiancaozuo(0)">一键下架</div> -->
						</div>
					<el-pagination background layout="total,prev,pager,next,jumper" :total="zongshu" :page-size="so.jitiao" :current-page.sync="so.ye" @current-change="CSH" style="margin-top: 30px;"/>
				</div>
			</el-tab-pane>
			<!-- <el-tab-pane :label="`仓库中商品(${zong[0]})`"  name="0" ></el-tab-pane>
			<el-tab-pane :label="`已经售罄商品(${zong[2]})`"  name="2" ></el-tab-pane>
			<el-tab-pane :label="`警戒库存(${zong[3]})`"  name="3" ></el-tab-pane>
			<el-tab-pane :label="`商品回收站(${zong[4]})`"  name="4" ></el-tab-pane> -->
			<el-tab-pane :label="shu.id?'编辑商品':'新增商品'" name="xinzeng" :closable="shu.id>0">
				<el-tabs>
					<!-- 基本信息 -->
					<el-tab-pane label="基本信息"  class="sp_from">
						<el-form :model="shu">							
							<el-form-item label="标题" label-width="100px">
								<el-input v-model="shu.ming"></el-input>
							</el-form-item>
							<!-- <el-form-item label="分类" label-width="100px">
								<Liandong :yiji.sync="shu.fenlei_yiji" :erji.sync="shu.fenlei_erji" :sanji.sync="shu.fenlei_sanji" :shu="fenleilie" v-if="shu && fenleilie"></Liandong>
							</el-form-item> -->
						<!-- 	<el-form-item label="绑定商户" label-width="100px">
								<Shanghu :id.sync="shu.shanghu" :ming.sync="shu.shanghuming"></Shanghu>							
							</el-form-item> -->
							<el-form-item label="单位" label-width="100px">
								<el-input placeholder="商品单位,如:个/件" v-model="shu.danwei" />
							</el-form-item>
						<!-- 	<el-form-item label="标签" label-width="100px">
								<el-tag :type="(shu.xinpin==1)?'':'info'" effect="dark" class="eltag" @click="Biaoqian(shu,'xinpin')">新品</el-tag>
								<el-tag :type="(shu.tuijian==1)?'':'info'" effect="dark" class="eltag" @click="Biaoqian(shu,'tuijian')">推荐</el-tag>							
							</el-form-item> -->
						<!-- 	<el-form-item label="秒杀时间" v-if="shu.miaosha==1" label-width="100px">
								<el-date-picker v-model="shu.miaoshashijian" type="datetimerange" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期">
								</el-date-picker>
							</el-form-item>	 -->						
							<!-- <el-form-item label="商品专区" label-width="100px">
								<el-radio-group v-model="shu.cuxiao">
									<el-radio-button label="0">普通</el-radio-button>
									<el-radio-button label="1">拼团</el-radio-button>
									<el-radio-button label="2">兑换</el-radio-button>
									<el-radio-button label="3">砍价</el-radio-button>
								</el-radio-group>
							</el-form-item> -->
							<el-form-item label="商品主图" label-width="100px">
								<Shangwenjian v-model="shu.tu" anniu="上传图片" leixing="tu"></Shangwenjian>							
							</el-form-item>
							<el-form-item label="小视频" label-width="100px">
								<Shangwenjian v-model="shu.shipin" anniu="上传小视频" leixing="yinpin"></Shangwenjian>
							</el-form-item>
							<el-form-item label="细节图" label-width="100px">
								<Shangtu v-model="shu.xijietu" shuliang="5"></Shangtu>
							</el-form-item>
							<el-form-item label="商品价格" label-width="100px">
							<!-- 	<el-input placeholder="请输入售价" v-model="shu.jiage">
									<template slot="prepend">售价</template>
									<template slot="append">元</template>
								</el-input> -->
								<!-- 拼团 -->
								<!-- <el-input placeholder="请输入内容" style="width:40%;" v-show="index==2">
									<template slot="prepend">拼团价</template>
									<template slot="append">元</template>
								</el-input>
								<el-input placeholder="请输入内容" style="width:40%;" v-show="index==2">
									<template slot="prepend">人数</template>
									<template slot="append">人</template>
								</el-input> -->
								<!-- 砍价 -->
								<!-- <template>
									<el-input placeholder="请输入内容" style="width:33%;" v-show="index==4">
										<template slot="prepend">砍价</template>
										<template slot="append">元</template>
									</el-input>
									<el-input placeholder="请输入内容" style="width:33%;" v-show="index==4">
										<template slot="prepend">人数</template>
										<template slot="append">人</template>
									</el-input>
									<el-input placeholder="请输入内容" style="width:33%;" v-show="index==4">
										<template slot="prepend">最低砍至</template>
										<template slot="append">元</template>
									</el-input>
								</template> -->
								<!-- 普通 -->
								<!-- <el-input placeholder="请输入原价" style="margin-top: 20px;" v-model="shu.yuanjia">
									<template slot="prepend">原价</template>
									<template slot="append">元</template>
								</el-input> -->
								<el-input placeholder="请输入成本价" style="margin-top: 20px;" v-model="shu.chengben">
									<template slot="prepend">成本价</template>
									<template slot="append">元</template>
								</el-input>
							</el-form-item>
							<el-form-item label="重量" label-width="100px">
								<el-input placeholder="请输入重量" v-model="shu.zhongliang">
									<template slot="append">克</template>
								</el-input>
							</el-form-item>
							<el-form-item label="库存" label-width="100px">
								<el-input placeholder="请输入库存" v-model="shu.kucun">
									<template slot="append">{{shu.danwei?shu.danwei:'个'}}</template>
								</el-input>
							</el-form-item>
						<!-- 	<el-form-item label="单次最多购买" label-width="100px">
								<el-input placeholder="单次最多购买商品数量" v-model="shu.yicizuiduomai">
									<template slot="append">{{shu.danwei?shu.danwei:'个'}}</template>
								</el-input>
							</el-form-item>
							<el-form-item label="单次最少购买" label-width="100px">
								<el-input placeholder="单次最少购买商品数量" v-model="shu.yicizuishaomai">
									<template slot="append">{{shu.danwei?shu.danwei:'个'}}</template>
								</el-input>
							</el-form-item>
							<el-form-item label="最多购买量" label-width="100px">
								<el-input placeholder="用户最多购买该商品数量,超出不可再购买" v-model="shu.zuiduomai">
									<template slot="append">{{shu.danwei?shu.danwei:'个'}}</template>
								</el-input>
							</el-form-item> -->
							<el-form-item label="销量" label-width="100px">
								<el-input v-model="shu.chushoushu"></el-input>
							</el-form-item>
							
						<!-- 	<el-form-item label="赠送积分" label-width="100px">
								<el-input placeholder="购买该商品赠送积分" v-model="shu.jifen">
									<template slot="append">个</template>
								</el-input>
							</el-form-item> -->
							<el-form-item label="配送方式" label-width="100px">
								<el-radio-group v-model="shu.peisongfangshi">
									<!-- <el-radio label="0" >快递物流</el-radio> -->
									<el-radio label="1" >到店自提</el-radio>
									<el-radio label="3" >门店配送</el-radio>
								</el-radio-group>
							</el-form-item>
							<!-- <el-form-item label="运费设置" label-width="100px">
								<div v-for="(jl,i) in shu.julilie" style="width: 40%;display: flex;margin-bottom: 10px;">
									<el-input placeholder="配送范围"  v-model="jl.juli">
										<template slot="append">米内</template>
									</el-input>
									<el-input placeholder="配送费"  v-model="jl.yunfei">
										<template slot="append">(元)</template>
									</el-input>
									<el-button  type="danger"  @click="shangjuli(i)">删除</el-button>
								</div>
								<el-button @click="Julijia">添加配送范围</el-button>
							</el-form-item> -->
							<el-form-item>
								<Tijiao @click="Tijiao"></Tijiao>
							</el-form-item>
						</el-form>
					</el-tab-pane>
					<!-- 商品描述 -->
					<el-tab-pane label="商品描述">
						<Bianjiqi v-model="shu.xiangqing" ming="xiangqing"></Bianjiqi>
						<Tijiao @click="Tijiao"></Tijiao>
					</el-tab-pane>
					<!-- 自定义属性 -->
				<!-- 	<el-tab-pane label="自定义属性">
						<el-form ref="form" :model="form">
							<div style="display: flex;flex-wrap: nowrap; margin-left: 1.875rem;">
								<el-form-item v-for="l in shuXin" :label="l.label" label-width="" style="width: 30%;">
									<el-input style="width: 60%;"></el-input>
								</el-form-item>
							</div>
							<el-form-item>
								<el-button>添加属性</el-button>
							</el-form-item>
						</el-form>
					</el-tab-pane> -->
					<!--  商品规格-->
					<el-tab-pane label="商品规格">
						<div>
							<span style="color: #606266; font-size: 14px;margin-left: 100px;margin-right: 20px;">是否启用商品规格</span>
							<el-checkbox v-model="shu.kaiqiguige" true-label='1' false-label="0">启用</el-checkbox>		
						</div>										
						<Guige :shu.sync="shu.guige" :guigezu.sync="shu.guigezu" style="margin-top: 40px;" v-if="shu.kaiqiguige==1"></Guige>	
						<Tijiao @click="Tijiao" style="margin-top: 10px;"></Tijiao>						
					</el-tab-pane>
					<!-- 会员权限 -->
				<!-- 	<el-tab-pane label="会员权限" class="sp_from">
						<el-form ref="form" :model="shu">
							<el-form-item label="会员角色购买权限" label-width="180px">
								<el-radio-group v-model="shu.goumaiquanxian">
									<el-radio label="0" >不限</el-radio>
									<el-radio :label="l.id" v-for="(l,i) in dengJilie" :key="i">{{l.ming}}</el-radio>	
								</el-radio-group>
							</el-form-item>
							<el-form-item label-width="80px">
								<el-tag>只有当折扣大于0的情况下才能生效，否则按自身会员角色折扣计算</el-tag>
							</el-form-item>
							<el-form-item label="会员角色折扣" label-width="180px">
								<el-input placeholder="请输入折扣" v-model="shu.zhekou[i]" size="small" v-for="(l,i) in dengJilie" :key="i">
									<template slot="prepend" size="small">{{l.ming}}</template>
									<template slot="append" size="small">折</template>
								</el-input>
							</el-form-item>
								<Tijiao @click="Tijiao" ></Tijiao>
						</el-form>
					
					</el-tab-pane> -->
					<!-- 营销 -->
				<!-- 	<el-tab-pane label="营销" class="sp_from">
						<el-form  :model="shu">
							<el-form-item label="积分抵扣" label-width="180px">
								<el-input placeholder="设置可用积分进行抵扣的金额" v-model="shu.yingxiao.jifen" size="small">
									<template slot="prepend" size="small">最多抵扣</template>
									<template slot="append" size="small">个</template>
								</el-input>								
							</el-form-item>
							<el-form-item label="是否可用优惠券" label-width="180px">
								<el-radio-group v-model="shu.yongquan">
									<el-radio label="1">不可用券 </el-radio>
									<el-radio label="0">可以用券</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="是否参与会员折扣" label-width="180px">
								<el-radio-group v-model="shu.canyuzhekou">
									<el-radio label="1">不参与 </el-radio>
									<el-radio label="0">参与</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label-width="180px">
								<Tijiao @click="Tijiao" ></Tijiao>
							</el-form-item>
						</el-form>
						
					</el-tab-pane> -->
					<!-- 分销设置 -->
					<!-- <el-tab-pane label="分销设置" class="sp_from">
						<el-form  :model="shu">
							<el-form-item label="是否参与分销" label-width="180px">
								<el-radio-group v-model="shu.canyufenxiao">
									<el-radio label="1">参与分销 </el-radio>
									<el-radio label="0">不参与分销</el-radio>
								</el-radio-group>
								<div class="tishi">如果不参与分销，则不产生分销佣金</div>
							</el-form-item>
							<el-form-item label="购此商品分销角色升为：" label-width="180px">
								<el-radio-group v-model="shu.dengji">
									<el-radio label="0" >不升级</el-radio>
									<el-radio :label="l.id" v-for="(l,i) in dengJilie" :key="i">{{l.ming}}</el-radio>	
								</el-radio-group>
							</el-form-item>
							<el-form-item label="独立规则：" label-width="180px">
								<el-radio v-model="shu.dulifenyong" label="0">不启动独立佣金</el-radio>
								<el-radio v-model="shu.dulifenyong" label="1">启动独立佣金</el-radio>
								<div class="tishi">启用独立佣金设置，此商品拥有独自的佣金比例,不受分销角色比例及默认设置限制</div>
							</el-form-item>
							<el-form-item v-if="shu.dulifenyong==1" :label="(i+1)+'级佣金'" label-width="180px" v-for="(l,i) in shu.duliyongjin" :key="i">
								<el-input placeholder="请输入内容" v-model="l.bilie" class="input-with-select" />
							</el-form-item>
							<el-form-item label-width="180px">
								<Tijiao @click="Tijiao"></Tijiao>
							</el-form-item>
						</el-form>
					</el-tab-pane> -->
				</el-tabs>
			</el-tab-pane>
			
		</el-tabs>
	</div>
</template>

<script>
	let that;
	import Shangtu from '../../zujian/Shangtu.vue'
	// import shangchuan from '../../zujian/jichu/shangchuan.vue'
	import Bianjiqi from '../../zujian/Bianjiqi.vue'
	import Liandong from '../../zujian/Liandong.vue'
	import Huiyuan from '../../zujian/Huiyuan.vue'
	import Shangwenjian from '../../zujian/Shangwenjian.vue'
	// import Guige from '../../zujian/Guige.vue'
	import Guige from '../../zujian/Guige2.vue'
	import Shanghu from '../../zujian/Shanghu.vue'
	export default {
		data() {
			return {
				shu: {				
					guige:[],
					guigezu:[],
					yingxiao:{},
					  // visible: false,
					goumaiquanxian:'0',
					zhekou:[],
					dengji:'0',
					dulifenyong:'0',
					julilie:[]
				},
				fenleilie: [],
				so: {
					ye: 1,
					jitiao: 10,
				},
				zongshu:0,
				zong:[0,0,0,0,0,0,0,0],
				lie: [],
				dengJilie: [],
				dengJilie_obj: [],
				tabs:'lie',	
				kuaidilie:[],
				duliyongjin: 0,
				zhuangtailie:[{ming:'出售中',zhi:'1'},{ming:'放入仓库',zhi:'0'},{ming:'回收站',zhi:'4'}],
			}

		},
		created() {
			that = this;
			this.CSH();
			this.Dengjilie();
			this.Fenlei();
			this.Kuaidi();
			this.Peizhi();
			console.log(this.$qu('shanghu'))
			
		},
		components: {
			Shangtu,
			// shangchuan,
			Bianjiqi,
			Liandong,
			Huiyuan,
			Shangwenjian,
			Guige,
			Shanghu
		},
		methods: {
			yijiancaozuo(e) {
				var ids = '';
				for (var i in this.$refs.huiYuanlie.selection) {
					ids += ',' + this.$refs.huiYuanlie.selection[i].id;
				}
				ids = ids.substr(1);
				if (ids) {
					this.$confirm('确定对商品进行修改吗？', '重要警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$post("m=limitao&k=shangpin&c=yijiancaozuo&zhuangtai="+e, {
							ids: ids
						}, function(s) {
							that.$xiaoxi(s.shu);
							if (s.shi == 1) {
								that.CSH();
							}
						})
					}).catch(() => {
			
					});
			
				}
			
			},
			// 距离
			Julijia(){
				if(!this.shu.julilie){
					this.shu.julilie=[]
				}
				this.shu.julilie.push({juli:0,yunfei:0})
			},
			shangjuli(e){
				this.shu.julilie.splice(e,1)
			},
			Danchu(){
				this.$post('m=limitao&k=shangpin&c=Daochu', that.so, function(s) {
					if(s.shi==1){
						window.open(that.$url+'?k=denglu&c=daochu&wenjianming='+s.shu);  
					}else{
						that.$xiaoxi(s.shu);			
					}
				});
			},
			gaizhuangtai(e,z){
				// if(this.tabs=='xinzeng'){
				// 	if(!this.shu.goumaiquanxian){
				// 		this.shu.goumaiquanxian=0;
				// 		this.$set(this.shu,'goumaiquanxian',0);
				// 	}
				// }
				// console.log(this.tabs)
				// console.log(e)
				// this.so.zhuangtai=e.name;
				this.CSH();
			},
			copyLink(e,url) {
				let that=this;
			   let clipboard = new this.clipboard(e.target,{ text: () => '/pages/Limitao/xiangqing?id='+url });
			   clipboard.on('success', function () {
				  that.$xiaoxi('复制成功')
			   });
			   clipboard.on('error', function () {
				that.$xiaoxi('复制失败')
			   });
			 },
			CSH() {
				that.so.mendianchangpin=1
				this.$post('m=limitao&k=shangpin', that.so, function(s) {
					that.lie = s.shu.lie;
					that.zongshu = Number(s.shu.zongshu);
					that.zong =s.shu.zong;
				});
			},
			Dengjilie() {
				this.$post('k=huiyuan&c=dengjilie', function(s) {
					that.dengJilie_obj = s.shu;
					that.dengJilie=[];
					for (var i in s.shu) {
						that.dengJilie.push(s.shu[i])
					}
			
				});
			},
			Fenlei() {
				this.$post('m=limitao&k=shangpin&c=quanbufenlei', function(s) {
					if (s.shi == 1) {
						that.fenleilie = s.shu;
					}
				});
			},
			Peizhi() {
				this.$post('k=peizhi', {
					shui: 'jichupeizhi'
				}, function(s) {
					that.duliyongjin = Number(s.shu.cengji);
				});
			},
			Tijiao(){			
				that.shu.mendianchangpin=1
				this.$post('m=limitao&k=shangpin&c=xiugai',that.shu,function(s) {					
					if(s.shi){						
						if(!that.shu.id){						
							setTimeout(function(){
								that.$xiaoxi("新增成功");
								for(var i in that.lie){
									if(that.lie[i].id==s.shu)that.Bianji(that.lie[i]);
								}
							},500)							
						}else{
						    that.$xiaoxi(s.shu)
						}	
						that.shu={}
						that.CSH();
					}else{
						that.$xiaoxi(s.shu);
					}
				});
			},
			Bianji(e){
				that.shu=[];
				that.tabs='xinzeng';
				that.shu=e;
				if (!that.shu.duliyongjin) {
					this.$set(that.shu, 'duliyongjin', []);
				}

				if (!that.shu.yingxiao.jifen) {
					this.$set(that.shu, 'yingxiao', {});
				}
				for (var i = 0; i < this.duliyongjin; i++) {
					if (!that.shu.duliyongjin[i]) {
						that.shu.duliyongjin.push({
							bilie: 0
						});
					}
				}
				if (that.shu.duliyongjin.length > this.duliyongjin) {
					that.shu.duliyongjin.splice(this.duliyongjin, that.shu.duliyongjin.length);
				}
				
			},			
			Tabremove(e){
				that.tabs='1';
				that.shu={				
					guige:[],
					guigezu:[],
					yingxiao:{},
					zhekou:[]					
				};
				
			},
			Shangxiajia(e){
				this.$post('m=limitao&k=shangpin&c=xiugai',{id:e.id,zhuangtai:e.zhuangtai},function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi){
						that.CSH();										
					}
				});
			},
			gaishuxing(e){
				this.$post('m=limitao&k=shangpin&c=xiugai',{...e},function(s) {
					that.$xiaoxi(s.shu);
					if(s.shi){
						that.CSH();										
					}
				});
			},

			Shanchu(e) {
				this.$confirm('确认删除?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					// this.shu.splice(e.$index, 1);
					this.$post('m=limitao&k=shangpin&c=shandiao',{id: e.id},function(s) {
						that.$xiaoxi(s.shu);
						if(s.shi){
							that.CSH();										
						}
					});
					
				});
			},
			
			
			
			Biaoqian(a,b,c){
				if(parseInt(a[b])){
					// a[b]=0;
					this.$set(a,b,0)
				}else{
					// a[b]=1
					this.$set(a,b,1)
				}	
				if(c){
					var s={};
					s['id']=a.id;
					s[b]=a[b];
					this.$post('m=limitao&k=shangpin&c=xiugai',s,function(s) {
						that.$xiaoxi(s.shu);					
					});
				}		
			},
			Kuaidi() {
				this.$post('k=kuaidi', that.so, function(s) {
					that.kuaidilie = s.shu.lie;					
				});
			},
			Xuanlie() {
				this.$refs.huiYuanlie.toggleAllSelection()
			},
			ShanchuHuiYuan() {
				var ids = '';
				for (var i in this.$refs.huiYuanlie.selection) {
					ids += ',' + this.$refs.huiYuanlie.selection[i].id;
				}
				ids = ids.substr(1);
				if (ids) {
					this.$confirm('会同时删除相关数据，可能会影响数据统计的结果，谨慎删除，不可恢复', '重要警告', {
						confirmButtonText: '确定',
						cancelButtonText: '取消',
						type: 'warning'
					}).then(() => {
						that.$post("m=limitao&k=shangpin&c=shanchu", {
							ids: ids
						}, function(s) {
							that.$xiaoxi(s.shu);
							if (s.shi == 1) {
								that.CSH();
							}
						})
					}).catch(() => {
			
					});
			
				}
			
			}
			
			
		}
	} 
</script>
<style scope>
	.sp_from .el-form{padding-top:30px}
	.shangchu_shangchu0{padding-top: 34px;padding-left: 12px;cursor:pointer}
	.shangchu_shangchu1{margin: 0 4px; font-size: 12px;padding: 0 5px;color: #fff;display: inline-block;padding: 2px 4px;background-color: #f56b6c;border-radius: 4px;}
	
	.shangchu_shangchu2{margin: 0 4px; font-size: 12px;padding: 0 5px;color: #fff;display: inline-block;padding: 2px 4px;background-color: #00B0E8;border-radius: 4px;}
	.shangchu_shangchu3{margin: 0 4px; font-size: 12px;padding: 0 5px;color: #fff;display: inline-block;padding: 2px 4px;background-color: #23241F;border-radius: 4px;}
	
	
	.el-dropdown {
		vertical-align: top;
	}

	.el-dropdown+.el-dropdown {
		margin-left: 15px;
	}

	.el-icon-arrow-down {
		font-size: 12px;
	}

	.biaoti {
		display: block;
		width: 100%;
		text-indent: 10px;
		margin-bottom: 16px;
		font-size: 20px;
		color: #788188;
	}

	.leixin {
		color: #f05050;
		/* position: absolute;
		top: 4px; */
	}

	.leixin2 {
		color: #4cb6cb;
		margin-left: -10px;
		/* position: absolute;
		top: 4px;
		left: 117px; */
	}
	.shangtu .el-upload--picture-card {
		width: 100px;
		height: 100px;
		display: flex;
		justify-content: center;
		align-items: center;
	}
	.leixin3 {
		color: #008000;
		display: block;
		display: flex;
	/* 	position: absolute;
		top: 4px;
		left: 169px; */
	}
	.leixin5{
		width: 19px;
		margin: 0 4px;
	}
	.leixin4 {
		    color: #788188;
		    width: 232px;
		    display: block;
		    line-height: 16px;
			margin-top: 9px;
			margin-left:6px;
		   /* position: absolute;
		    top: 38px;
		    left: 66px; */
		
	}

	.zhuantai {
		margin-left: 10px;
	}
	.eltag{
		margin-right: 5px;cursor: pointer;
	}
	.el-table_1_column_3 .cell{
		display: flex;
	}
</style>
